module.exports = __webpack_public_path__ + "img/icon5.baab29bf.svg";